import React from 'react'
export default function MinimalLeftIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M11.1 15.7 3.4 8 11.1.3l1.5 1.4L6.3 8l6.3 6.3z"/></g></svg>)
}
